/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

module.exports = {
  EVENT_END_DELAY: 100,
  DEFAULT_THROTTLE_RATE: 50
};



//////////////////
// WEBPACK FOOTER
// ./~/subscribe-ui-event/dist/constants.js
// module id = 607
// module chunks = 0